import { StoryMediaType, type Story } from '@/@types/story'

interface StoryMediaBase {
	alt: string
	loading?: boolean
	errorMessage?: string
}

export interface StoryPictureMedia extends StoryMediaBase {
	type: 'PICTURE'
	url?: string
}

export interface StoryVideoMedia extends StoryMediaBase {
	type: 'VIDEO'
	url?: string
	posterUrl?: string
	initialTime?: number
	isPlaying: boolean
	isMuted: boolean
}

export type StoryMedia = StoryPictureMedia | StoryVideoMedia

export const getStoryPosterUrl = (story: Story | undefined) => {
	if (!story) return undefined

	if (story.storyType === StoryMediaType.VIDEO) {
		return (
			story.video?.image?.picUrl ?? story.thumbnailVideo?.image?.picUrl ?? story.picture?.picUrl
		)
	}

	return story.picture?.picUrl
}

export const getStoryPreviewUrl = (story: Story) => {
	if (story.storyType !== StoryMediaType.VIDEO) return story.picture?.picUrl

	// 非前景视频 Story 应展示接口提供的 picture 静态封面；旧数据缺失 picture 时再回退到视频封面。
	return story.picture?.picUrl ?? story.video?.image?.picUrl ?? story.thumbnailVideo?.image?.picUrl
}

export const getStoryPictureMedia = (story: Story): StoryMedia => {
	const url = story.picture?.picUrl

	return {
		type: 'PICTURE',
		url,
		alt: `${story.user.screenName}发布的图片日记`,
		errorMessage: url ? undefined : '这张图片暂时无法显示',
	}
}
